import { render, staticRenderFns } from "./ForwardToUserDialog.vue?vue&type=template&id=2629dd74&"
import script from "./ForwardToUserDialog.vue?vue&type=script&lang=js&"
export * from "./ForwardToUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports